import api from "@/api/api-change";

export async function getModuleConfigListAxios() {
  const response = await api.get("/tenants/getmoduleconfig");
  console.log("Raw API Response:", response.data);
  return response;
}
